/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { MeasValueType } from './MeasValueType';
import {
    MeasValueTypeFromJSON,
    MeasValueTypeFromJSONTyped,
    MeasValueTypeToJSON,
} from './MeasValueType';
import type { SequenceSubType } from './SequenceSubType';
import {
    SequenceSubTypeFromJSON,
    SequenceSubTypeFromJSONTyped,
    SequenceSubTypeToJSON,
} from './SequenceSubType';
import type { TrackItDataSequenceInfoDtoPositions } from './TrackItDataSequenceInfoDtoPositions';
import {
    TrackItDataSequenceInfoDtoPositionsFromJSON,
    TrackItDataSequenceInfoDtoPositionsFromJSONTyped,
    TrackItDataSequenceInfoDtoPositionsToJSON,
} from './TrackItDataSequenceInfoDtoPositions';

/**
 * 
 * @export
 * @interface TrackItDataSequenceInfoDto
 */
export interface TrackItDataSequenceInfoDto {
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceInfoDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceInfoDto
     */
    measurementId?: number | null;
    /**
     * 
     * @type {MeasValueType}
     * @memberof TrackItDataSequenceInfoDto
     */
    measurementType?: MeasValueType;
    /**
     * 
     * @type {SequenceSubType}
     * @memberof TrackItDataSequenceInfoDto
     */
    sequencePartType?: SequenceSubType;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataSequenceInfoDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataSequenceInfoDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceInfoDto
     */
    byteCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceInfoDto
     */
    pointCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataSequenceInfoDto
     */
    scalarValue?: string | null;
    /**
     * 
     * @type {TrackItDataSequenceInfoDtoPositions}
     * @memberof TrackItDataSequenceInfoDto
     */
    positions?: TrackItDataSequenceInfoDtoPositions | null;
    /**
     * 
     * @type {TrackItDataSequenceInfoDtoPositions}
     * @memberof TrackItDataSequenceInfoDto
     */
    chamberNumbers?: TrackItDataSequenceInfoDtoPositions | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataSequenceInfoDto
     */
    $type?: TrackItDataSequenceInfoDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItDataSequenceInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItDataSequenceInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataSequenceInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItDataSequenceInfoDtoTypeEnum = typeof TrackItDataSequenceInfoDtoTypeEnum[keyof typeof TrackItDataSequenceInfoDtoTypeEnum];



/**
 * Check if a given object implements the TrackItDataSequenceInfoDto interface.
 */
export function instanceOfTrackItDataSequenceInfoDto(value?: unknown): value is TrackItDataSequenceInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItDataSequenceInfoDtoTypeEnum)[0];
}

export function TrackItDataSequenceInfoDtoFromJSON(json: any): TrackItDataSequenceInfoDto {
    return TrackItDataSequenceInfoDtoFromJSONTyped(json, false);
}

export function TrackItDataSequenceInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItDataSequenceInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'measurementId': json['measurementId'] == null ? undefined : json['measurementId'],
        'measurementType': json['measurementType'] == null ? undefined : MeasValueTypeFromJSON(json['measurementType']),
        'sequencePartType': json['sequencePartType'] == null ? undefined : SequenceSubTypeFromJSON(json['sequencePartType']),
        'name': json['name'] == null ? undefined : json['name'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'byteCount': json['byteCount'] == null ? undefined : json['byteCount'],
        'pointCount': json['pointCount'] == null ? undefined : json['pointCount'],
        'scalarValue': json['scalarValue'] == null ? undefined : json['scalarValue'],
        'positions': json['positions'] == null ? undefined : TrackItDataSequenceInfoDtoPositionsFromJSON(json['positions']),
        'chamberNumbers': json['chamberNumbers'] == null ? undefined : TrackItDataSequenceInfoDtoPositionsFromJSON(json['chamberNumbers']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItDataSequenceInfoDtoToJSON(value?: TrackItDataSequenceInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'measurementId': value['measurementId'],
        'measurementType': MeasValueTypeToJSON(value['measurementType']),
        'sequencePartType': SequenceSubTypeToJSON(value['sequencePartType']),
        'name': value['name'],
        'unit': value['unit'],
        'byteCount': value['byteCount'],
        'pointCount': value['pointCount'],
        'scalarValue': value['scalarValue'],
        'positions': TrackItDataSequenceInfoDtoPositionsToJSON(value['positions']),
        'chamberNumbers': TrackItDataSequenceInfoDtoPositionsToJSON(value['chamberNumbers']),
        '$type': value['$type'],
    });
}

